"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pb = exports.pt = exports.pr = exports.pl = exports.py = exports.px = exports.p = exports.mb = exports.mt = exports.mr = exports.ml = exports.my = exports.mx = exports.m = exports.spacing = void 0;
exports.spacing = {
    '0x': '0',
    '1x': '0.125rem',
    '2x': '0.250rem',
    '4x': '0.500rem',
    '5x': '0.625rem',
    '6x': '0.750rem',
    '8x': '1.000rem',
    '10x': '1.25rem',
    '12x': '1.50rem',
    '16x': '2.00rem',
};
var createSpacingFn = function (params) { return function (multiplier) {
    return params.map(function (param) { return param + ": " + exports.spacing[multiplier]; }).join('');
}; };
exports.m = createSpacingFn(['margin']);
exports.mx = createSpacingFn(['margin-left', 'margin-right']);
exports.my = createSpacingFn(['margin-top', 'margin-bottom']);
exports.ml = createSpacingFn(['margin-left']);
exports.mr = createSpacingFn(['margin-right']);
exports.mt = createSpacingFn(['margin-top']);
exports.mb = createSpacingFn(['margin-bottom']);
exports.p = createSpacingFn(['padding']);
exports.px = createSpacingFn(['padding-left', 'padding-right']);
exports.py = createSpacingFn(['padding-top', 'padding-bottom']);
exports.pl = createSpacingFn(['padding-left']);
exports.pr = createSpacingFn(['padding-right']);
exports.pt = createSpacingFn(['padding-top']);
exports.pb = createSpacingFn(['padding-bottom']);
//# sourceMappingURL=spacing.js.map